import { async } from "q"
import { axiosGet, axiosPost } from "../../../../../react_axios/Axios"
import { headers, getDelegateMeetingDetailsUrl, getDefaultDelegateMeetingUrl, insertUpdateDelegateMeetingUrl, GET_DEFAULT_DELEGATE_MEETING, GET_DELEGATE_MEETING_DETAILS, INSERT_UPDATE_DELEGATE_MEETING } from "../../../../../utils/constants"

export const getDefaultDelegateMeeting_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }

        const res = await axiosGet(getDefaultDelegateMeetingUrl, params)
        dispatch({
            type: GET_DEFAULT_DELEGATE_MEETING,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateMeetingDetails_action = (DelegateMeetingID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhregistertionID: parseInt(sessionStorage.getItem('ExhRegistrationIDSS')),
            DelegateMeetingID: DelegateMeetingID,
        }

        const res = await axiosGet(getDelegateMeetingDetailsUrl, params)
        dispatch({
            type: GET_DELEGATE_MEETING_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateDelegateMeeting_action = (DelegateMeetingList) => async (dispatch) => {
    try {
        const mapData = {
            UserID: parseInt(JSON.parse(sessionStorage.getItem('loginDataSS')).UserID),
            ExhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
            ExhregistrationID: parseInt(sessionStorage.getItem('ExhRegistrationIDSS')),
            DelegateMeetingList: DelegateMeetingList,
        }
        const res = await axiosPost(insertUpdateDelegateMeetingUrl, mapData, headers)

        dispatch({
            type: INSERT_UPDATE_DELEGATE_MEETING,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
